export * from "./account"
export * from "./auth"
export * from "./benefit"
export * from "./employer"
export * from "./household"
export * from "./income"
export * from "./person"
export * from "./property"
export * from "./scenario"
export * from "./user"
export * from "./goal"
export * from "./proposal"
export * from "./extras"
export * from "./courses"

export async function setup(store) {
  if (window) {
    window.app = store
    window.app.toggleLogging = loggingState => {
      if (loggingState == null) {
        window.__isAppLogging = !window.__isAppLogging
      } else {
        window.__isAppLogging = loggingState
      }
      return window.__isAppLogging ? "on" : "off"
    }
  }
}

export async function teardown(store) {
  if (window) {
    window.app = null
  }
}
